import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { LeftConsole } from "./LeftConsole";
import { Button } from "@/components/ui/button";
import { useActiveNearby } from "@/hooks/useActiveNearby";
import { useSuggestedUsers } from "@/hooks/useSuggestedUsers";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function MobileLeftConsole() {
  const [user, setUser] = useState<User | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  // Set up auth state
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setUser(session?.user ?? null);
      }
    );

    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Fetch data inside the component
  const { data: activeNearby = [] } = useActiveNearby(undefined, undefined, 25, 20);
  const { data: suggested = [] } = useSuggestedUsers(20);
  
  // TODO: fetch real notifications and messages
  const notifications = [
    { id:"n1", kind:"mention" as const, title:"@you in #cocoa", preview:"Can you verify price?", ts:new Date().toISOString(), unread:true, link:"/posts/123" },
  ];
  const threads = [
    { id:"t1", peerId:"u9", peerName:"Abena", lastSnippet:"Let's talk drying racks", ts:new Date().toISOString(), unreadCount:2 },
  ];
  
  const handleNavigateToDiscover = (): void => {
    console.log("MobileLeftConsole: Navigating to discover teams");
    setSearchParams({ tab: 'discover', view: 'teams' });
  };

  console.log("MobileLeftConsole rendered, handleNavigateToDiscover defined:", typeof handleNavigateToDiscover);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Open activity menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-[300px]">
        <LeftConsole
          activeNearby={activeNearby}
          suggested={suggested}
          notifications={notifications}
          threads={threads}
          onFollow={(id)=>console.log("follow", id)}
          onMessage={(id)=>console.log("DM", id)}
          className="h-full border-r-0"
          user={user}
          onNavigateToDiscover={handleNavigateToDiscover}
        />
      </SheetContent>
    </Sheet>
  );
}
